import { render, staticRenderFns } from "./SubmitTargetBranch.vue?vue&type=template&id=7c8001f9"
import script from "./SubmitTargetBranch.vue?vue&type=script&lang=js"
export * from "./SubmitTargetBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports